/**
 * Status einer Veranstaltung
 */
export enum EventStatus {
   /**
    * Veranstaltung ist noch ein Entwurf.
    */
   draft = "draft",

   /**
    * Veranstaltung wird angezeigt.
    */
   displayed = "displayed",

   /**
    * Veranstaltung ist ausgeblendet und wird in keinem Fall angezeigt.
    */
   hidden = "hidden",

   /**
    * Veranstaltung wurde abgesagt.
    */
   canceled = "canceled",
}

export const EventStatusNames = {
  draft: "Entwurf",
  displayed: "Darf angezeigt werden",
  hidden: "Wird nicht angezeigt",
  canceled: "Abgesagt"
};